/* eslint-disable @typescript-eslint/no-unused-vars */
import userService from "@/services/user.service"
import { ActionContext, Store } from "vuex"
import { omit } from "lodash"
import { buildUserPatcher, buildUserProxy } from "@/utils/userPatcher"

const state: any = {
    allUser: {},
    allOrgs: {},
    orgUser: [],
    orgs: []
}

export type State = typeof state

const getters = {
    allUser: (state: State) => state.allUser,
    allOrgs: (state: State) => state.allOrgs,
    orgUser: (state: State) => state.orgUser,
    orgs: (state: State) => state.orgs
}

const userPatcher = buildUserPatcher("pubui/patchUser")
const actions = (_pid: string) => ({
    async getUserList({ commit }: ActionContext<State, any>) {
        commit("setAllUser", await userService.getUserList())
    },
    async getAllUserList({ commit }: ActionContext<State, any>) {
        commit("setAllUserList", await userService.getAllUserList())
    },
    async getOrgs(context: ActionContext<State, any>) {
        context.commit("setOrgs", await userService.getOrgList())
    }
})

const mutations = {
    setAllUser(state: State, data: any) {
        const _data = JSON.parse(JSON.stringify(data))
        state.orgUser = [_data]
    },
    setAllUserList(state: State, data: any) {
        state.allUser = buildUserProxy(data, userPatcher)
    },
    patchUser(state: State, data: any[]) {
        const patch = data.reduce((prev, cur) => {
            const { department_tree_path_str, email, name, oid, thumb_avatar, uid } = cur
            return {
                ...prev,
                [cur.uid]: {
                    uid: uid,
                    avatar: thumb_avatar,
                    name: name,
                    email: email,
                    department_tree_name: department_tree_path_str,
                    department_id: oid
                }
            }
        }, {})
        state.allUser = buildUserProxy({ ...state.allUser, ...patch }, userPatcher)
    },

    setOrgs(state: State, data: any) {
        const orgsArr = [data]
        const orgs: Record<string, any> = {}
        const handle = (arr: any[]) => {
            arr.forEach(elem => {
                if (elem.child_org && elem.child_org.length > 0) {
                    handle(elem.child_org)
                }
                const node = omit(elem, ["child_org", "user_list"])
                orgs[node.oid] = node
            })
        }
        handle(orgsArr)
        state.orgs = orgsArr
        state.allOrgs = orgs
    }
}

export default {
    registerModule(store: Store<any>, pid: string) {
        if (!store.state.pubui) {
            store.registerModule("pubui", {
                namespaced: true,
                state,
                actions: actions(pid),
                mutations,
                getters
            })
            store.dispatch("pubui/getUserList")
            store.dispatch("pubui/getAllUserList")
            store.dispatch("pubui/getOrgs")
        }
    },
    unregisterModule(store: Store<any>) {
        if (store.state.pubui) {
            store.unregisterModule("pubui")
        }
    }
}
